
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ApplyNowModal } from "@/components/common/ApplyNowModal";

export const SuccessStories = () => {
  const realStats = [
    {
      number: "₹100Cr+",
      label: "Loans Disbursed",
      color: "text-green-400"
    },
    {
      number: "150+",
      label: "Happy Customers",
      color: "text-blue-400"
    },
    {
      number: "98%",
      label: "Approval Rate",
      color: "text-purple-400"
    },
    {
      number: "48hrs",
      label: "Quick Processing",
      color: "text-yellow-400"
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Trusted by Thousands
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">
            Join our growing community of satisfied customers who achieved their financial goals
          </p>
        </div>

        {/* Real Statistics */}
        <div className="grid md:grid-cols-4 gap-6 mb-16">
          {realStats.map((stat, index) => (
            <Card key={index} className="bg-slate-800/50 backdrop-blur-lg border-slate-700 text-center hover:scale-105 transition-all duration-300">
              <CardContent className="p-6">
                <div className={`text-4xl font-bold ${stat.color} mb-2`}>{stat.number}</div>
                <div className="text-slate-300">{stat.label}</div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Customer Benefits */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {[
            {
              title: "Quick Approval",
              description: "Get loan approval in 48 hours with minimal documentation",
              icon: "⚡"
            },
            {
              title: "Competitive Rates",
              description: "Starting upto 8.99% interest rate for qualified applicants",
              icon: "💰"
            },
            {
              title: "Flexible Terms",
              description: "Choose tenure from 6 months to 30 years as per your needs",
              icon: "🎯"
            }
          ].map((benefit, index) => (
            <Card key={index} className="bg-slate-800/50 backdrop-blur-lg border-slate-700 hover:bg-slate-700/50 transition-all duration-300">
              <CardContent className="p-6 text-center">
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-semibold text-white mb-2">{benefit.title}</h3>
                <p className="text-slate-300">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <Card className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-lg border-slate-700 max-w-4xl mx-auto">
            <CardContent className="p-8">
              <h3 className="text-3xl font-bold text-white mb-4">Ready to Join Our Success Stories?</h3>
              <p className="text-slate-300 mb-8 text-lg">
                Start your financial journey today with instant loan approval
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <ApplyNowModal>
                  <Button className="bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-lg px-8 py-3">
                    Apply Now
                    <ArrowRight className="h-5 w-5 ml-2" />
                  </Button>
                </ApplyNowModal>

                <Button
                  variant="outline"
                  className="border-blue-500 text-blue-400 hover:bg-blue-500/10 text-lg px-8 py-3"
                  onClick={() => window.location.href = '/calculators'}
                >
                  Calculate EMI
                </Button>
              </div>

              <div className="mt-6 text-slate-400">
                <p>💬 Need help? Call us: <a href="tel:+919324471736" className="text-blue-400 hover:underline">+91 93244 71736</a></p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
